import React, { useEffect, useRef, useState } from 'react'
import { MdAdd, MdBlock, MdCreate, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import _constantUtil from '../../utils/Constant'
import { Tooltip } from 'react-tooltip'; 
import  profile from '../../assets/Asset 1 1.png'

function AllTeam() { 
    const storedTheme = sessionStorage.getItem('themeMode'); 
    const [page, setPage] = useState(_constantUtil.ONE);
    const [totalPages, setTotalPages] = useState(_constantUtil.ZERO);
    const [confirmation, setConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const [updateConfirmation, setUpdateConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const confirmationRef = useRef(_constantUtil.NULL); 
    const [icons, setIcons] = useState(profile)

    const handleImageChange = (event) => {
        const file = event.target.files[_constantUtil.ZERO];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setIcons(reader.result);
          };
          reader.onerror = (error) => {
            console.error("Error reading file:", error);
          };
          reader.readAsDataURL(file);
        }
      };

    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
            setConfirmation(_constantUtil.BOOLEAN_FALSE); 
            setUpdateConfirmation(_constantUtil.BOOLEAN_FALSE); 
            setShowConfirmation(_constantUtil.BOOLEAN_FALSE); 
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };    
    }, []); 

  return (
    <>
      {showConfirmation && (
          <div>
            <div className='confirmation-overlay'></div>
            <div ref={confirmationRef} className='confirmation-dialog'>
              <p>Are you sure to update team status ?</p>
              <div className='d-flex justify-content-end '>
                <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                <button className='border-0 rounded px-3 bg-success text-white p-2 me-0' > Confirm  </button>
              </div>
            </div>
          </div>
        )} 

        {confirmation && <>
            <div className='team-confirmation-overlay'></div>
            <div ref={confirmationRef} className={`${storedTheme === 'dark' ? 'match-dark-confirmation-dialog' :  'match-light-confirmation-dialog'}`}>
                <h4>Add Team</h4>
                <hr className='hr-color'/>  
                <form> 
                    <div className="row">   
                        <div className='col-12 col-md-6 my-auto  '>
                            <label htmlFor='team_name' className='form-label fw-semibold'>
                                Name
                            </label>
                            <input
                            type='text'
                            className='form-control w-100 my-auto' 
                            id='team_name'
                            name='name' 
                            placeholder='Enter Sports Name'
                            autoComplete='off'
                            /> 
                        </div>

                        <div className=" col-12  col-md-6 text-center sports-image">
                            <img
                            src={icons}
                            alt='Profile'
                            className='img-thumbnail img-fluid '
                            style={{
                                borderRadius: '50%',
                                cursor: 'pointer',
                                objectFit: 'cover',
                                minHeight: '110px',
                                height: '110px',
                                maxWidth: '110px',
                                width: '110px',
                                backgroundColor: 'white'
                            }}
                            /> 
                            <div className='button-wrapper pt-2 mt-2'>
                                <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                                <div className="d-flex justify-content-center">
                                <input
                                    type='file'
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleImageChange} 
                                    className=' upload-box form-control' 
                                    name='upload' 
                                    id='upload-modal'
                                    placeholder='Upload File'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='hr-color'/>
                    <div className='d-flex justify-content-end mt-3'>
                        <button onClick={()=>setConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
                        <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
                    </div>
                </form>
            </div>

        </>
        } 
        {updateConfirmation && <>
            <div className='team-confirmation-overlay'></div>
            <div ref={confirmationRef} className={`${storedTheme === 'dark' ? 'match-dark-confirmation-dialog' :  'match-light-confirmation-dialog'}`}>
                <h4>Update Team</h4>
                <hr className='hr-color'/>  
                <form> 
                    <div className="row">   
                        <div className='col-12 col-md-6 my-auto  '>
                            <label htmlFor='team_name' className='form-label fw-semibold'>
                                Name
                            </label>
                            <input
                            type='text'
                            className='form-control w-100 my-auto' 
                            id='team_name'
                            name='name' 
                            placeholder='Enter Sports Name'
                            autoComplete='off'
                            /> 
                        </div>

                        <div className=" col-12  col-md-6 text-center sports-image">
                            <img
                            src={icons}
                            alt='Profile'
                            className='img-thumbnail img-fluid '
                            style={{
                                borderRadius: '50%',
                                cursor: 'pointer',
                                objectFit: 'cover',
                                minHeight: '110px',
                                height: '110px',
                                maxWidth: '110px',
                                width: '110px',
                                backgroundColor: 'white'
                            }}
                            /> 
                            <div className='button-wrapper pt-2 mt-2'>
                                <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                                <div className="d-flex justify-content-center">
                                <input
                                    type='file'
                                    accept="image/png, image/jpeg, image/jpg"
                                    onChange={handleImageChange} 
                                    className=' upload-box form-control' 
                                    name='upload' 
                                    id='upload-modal'
                                    placeholder='Upload File'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className='hr-color'/>
                    <div className='d-flex justify-content-end mt-3'>
                        <button onClick={()=>setUpdateConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
                        <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
                    </div>
                </form>
            </div>

        </>
        }
       <div className='px-4 mt-4'>  
            <div className='container-fluid p-0'>
                <div className='row'>
                    <h4 className='header-title pb-3 text-muted'>All Team</h4>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <div className='d-flex'> 
                                        <input
                                            type='text'
                                            className='form-control me-2'
                                            id='search'
                                            name='search'
                                            placeholder='Search...' 
                                            autoComplete='off'
                                        />
                                    </div>
                                    <div className=' d-flex '>
                                        <div className=''>
                                            <button
                                                type='button'
                                                className='btn jumbo-bg-dull-sky text-white'
                                                onClick={() => setConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                            >
                                                <MdAdd className='fs-5 me-1 mb-1' />
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div> 
                                <div className='table-responsive'>
                                    <table id='scroll-horizontal-datatable' className='table w-100 nowrap'>
                                        <thead>
                                        <tr>
                                            <th>SN</th>  
                                            <th>Name</th>
                                            <th>Profile</th> 
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody> 
                                            <tr >
                                                <td>1</td> 
                                                <td>India</td>  
                                                <td>
                                                    <img src={profile} alt="profile" className='user-img'  />    
                                                </td> 
                                                <td> 
                                                    <span className='badge badge-success-lighten' style={{fontSize:'13px'}}>ACTIVE</span> 
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'> 
                                                        <MdCreate
                                                            data-tooltip-id='updatetournament' data-tooltip-content="Update Team"
                                                            className=' jumbo-icon  me-2 fs-5 jumbo-icon' style={{cursor: 'pointer', color:'gray'}} 
                                                            onClick={()=>setUpdateConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='updatetournament' place="bottom" effect="solid"/>  

                                                        <MdBlock
                                                            data-tooltip-id='inctive' data-tooltip-content="Inactive Team"
                                                            className='jumbo-icon pointer user-status fs-5 me-2 text-danger' style={{cursor: 'pointer'}}   
                                                            onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip id='inctive' place="bottom" effect="solid"/>
                                                    </div>
                                                </td>
                                            </tr>   
                                        </tbody>
                                    </table>                  
                                </div>
                                <ReactPaginate
                                    className='pagination'
                                    onPageChange={page => { setPage(page.selected + _constantUtil.ONE); }}
                                    pageCount={totalPages}
                                    previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                    nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                    marginPagesDisplayed={2}
                                    breakLabel={'...'}
                                    containerClassName={'pagination-container'}
                                    activeClassName={'pagination-active-page'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default AllTeam
